import React, { useEffect, useMemo, useRef, useState } from "react";
import styles from "./index.module.scss";
import useAgeGate from "../../../Hooks/useAgeGate";
import { useNavigate, useLocation } from "react-router-dom";
import { login, signup, manualdownload, adminLogin } from "../../../Api/SubUrl";

function getFocusableElements(container) {
  if (!container) return [];
  return Array.from(
    container.querySelectorAll(
      'button,[href],input,select,textarea,[tabindex]:not([tabindex="-1"])'
    )
  ).filter((el) => !el.hasAttribute("disabled") && !el.getAttribute("aria-hidden"));
}

export default function AgeGateCover() {
  const { verified, confirm } = useAgeGate();
  const dialogRef = useRef(null);
  const confirmBtnRef = useRef(null);
  const loginBtnRef = useRef(null);
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const [mode, setMode] = useState("age"); // "age" | "auth"

  const isOpen = useMemo(() => mode === "auth" || !verified, [mode, verified]);

  useEffect(() => {
    if (!isOpen) return;

    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";

    return () => {
      document.body.style.overflow = prevOverflow;
    };
  }, [isOpen]);

  useEffect(() => {
    if (!isOpen) return;

    // Focus correct primary action for keyboard users.
    const t = window.setTimeout(() => {
      if (mode === "auth") loginBtnRef.current?.focus?.();
      else confirmBtnRef.current?.focus?.();
    }, 0);

    const onKeyDown = (e) => {
      if (e.key !== "Tab") return;

      const focusables = getFocusableElements(dialogRef.current);
      if (focusables.length === 0) {
        e.preventDefault();
        return;
      }

      const first = focusables[0];
      const last = focusables[focusables.length - 1];
      const active = document.activeElement;

      if (e.shiftKey) {
        if (active === first || active === dialogRef.current) {
          e.preventDefault();
          last.focus();
        }
      } else {
        if (active === last) {
          e.preventDefault();
          first.focus();
        }
      }
    };

    document.addEventListener("keydown", onKeyDown, true);
    return () => {
      window.clearTimeout(t);
      document.removeEventListener("keydown", onKeyDown, true);
    };
  }, [isOpen, mode]);

  if (!isOpen) return null;

  const onDecline = () => {};
  const onConfirm = () => {
    confirm();
    if (pathname !== manualdownload && pathname !== adminLogin) setMode("auth");
  };

  const onGoLogin = () => {
    setMode("age");
    navigate(login);
  };
  const onGoSignup = () => {
    setMode("age");
    navigate(signup);
  };

  return (
    <div className={styles.backdrop}>
      <div
        ref={dialogRef}
        className={styles.dialog}
        role="dialog"
        aria-modal="true"
        aria-label={mode === "age" ? "Xác nhận độ tuổi" : "Đăng nhập hoặc đăng ký"}
        tabIndex={-1}
      >
        {mode === "age" ? (
          <>
            <h2 className={styles.title}>Xác nhận</h2>
            <p className={styles.content}>
              Bạn đủ <strong>18 tuổi trở lên</strong>?
              <br />
              Bạn cân nhắc tiếp tục?
            </p>
            <div className={styles.actions}>
              <button
                type="button"
                className={`${styles.btn} ${styles.btnSecondary}`}
                onClick={onDecline}
              >
                Huỷ
              </button>
              <button
                ref={confirmBtnRef}
                type="button"
                className={`${styles.btn} ${styles.btnPrimary}`}
                onClick={onConfirm}
              >
                Tiếp tục
              </button>
            </div>
          </>
        ) : (
          <>
            <h2 className={styles.title}>Tiếp tục</h2>
            <p className={styles.content}>
              Vui lòng chọn <strong>Đăng nhập</strong> hoặc <strong>Đăng ký</strong>{" "}
              để tiếp tục.
            </p>
            <div className={styles.actions}>
              <button
                ref={loginBtnRef}
                type="button"
                className={`${styles.btn} ${styles.btnSecondary}`}
                onClick={onGoLogin}
              >
                Đăng nhập
              </button>
              {/* <button
                type="button"
                className={`${styles.btn} ${styles.btnPrimary}`}
                onClick={onGoSignup}
              >
                Đăng ký
              </button> */}
            </div>
          </>
        )}
      </div>
    </div>
  );
}

